import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import IntelligencePostDetail from "@/pages/IntelligencePostDetail";

export const Route = createFileRoute("/_app/intelligence/posts/$id")({
  component: () => (
    <PageGate pageKey="intelligence"><IntelligencePostDetail /></PageGate>
  ),
});
